import { GridColumn } from 'src/components/GridWrapper';

export const ScanManagerErrorColumns: GridColumn<any>[] = [
  {
    field: 'fileName',
    title: 'File Name',
    width: '250px',
    menu: false,
  },
  {
    field: 'errorMessage',
    title: 'Error',
    menu: false,
  },
];
